import type { Policy } from './types';

/** Usernames, community names and anything else that names someone: nothing gets through. */
export const NAME_POLICY: Policy = {
  name: 'name',
  acrossWords: true,
  actions: {
    slur: 'block',
    sexual: 'block',
    profanity: 'block',
    violence: 'block',
    harassment: 'block',
    self_harm: 'block',
    drugs: 'block',
    impersonation: 'block',
  },
};

/**
 * A game's store listing (M30): what players read about a game before they play. Harmful
 * words are refused; drugs and posing as MOGZO aren't, since a farming game may grow weed and
 * Quarkfox's own games say "by Quarkfox". Reviewers read every listing too.
 */
export const LISTING_POLICY: Policy = {
  name: 'listing',
  acrossWords: false,
  actions: {
    slur: 'block',
    sexual: 'block',
    profanity: 'block',
    violence: 'block',
    harassment: 'block',
    self_harm: 'block',
    drugs: 'allow',
    impersonation: 'allow',
  },
};

/**
 * Chat, posts and comments, when they use it: slurs, threats and telling someone to hurt
 * themselves are refused, swearing and sexual words are hidden, and talk of one's own
 * self-harm goes through for staff to look at (the writer may need help, not a wall). Saying
 * "admin" or "mod" is fine in a sentence.
 */
export const MESSAGE_POLICY: Policy = {
  name: 'message',
  acrossWords: false,
  actions: {
    slur: 'block',
    sexual: 'mask',
    profanity: 'mask',
    violence: 'block',
    harassment: 'block',
    self_harm: 'review',
    drugs: 'allow',
    impersonation: 'allow',
  },
};
